<template id="XhGs">
  <!--<div id="XHGS_pic">
    <img src="../../../static/images/BPHYGS1.jpg" style="width:190px;height:315px;">
    <img src="../../../static/images/BPHYGS2.jpg" style="width:190px;height:315px;">
    <span>循环泵控制柜</span>
    <img src="../../../static/images/xhhygs1.jpg" style="width:190px;height:315px;">
    <img src="../../../static/images/xhhygs2.jpg" style="width:190px;height:315px;">
    <span>变频恒压供水</span>
  </div>-->
  <div class="htmleaf-container">
    <Viewer :images="images">
      <img v-for="src in images" :src="src.url" :key="src">
    </Viewer>
    <div class="container gallery-container">
      <h1>循环泵控制柜&变频恒压供水</h1>
      <!-- <p class="page-description text-center">Thumbnails With Title And Description</p>-->
      <div class="tz-gallery">
        <div class="row images" v-viewer>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/BPHYGS1.jpg" alt="BPHYGS1">
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/BPHYGS2.jpg" alt="BPHYGS2">
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/xhhygs1.jpg" alt="xhhygs1">
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/xhhygs2.jpg" alt="xhhygs2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 引入 viewerjs 的 CSS 文件
import 'viewerjs/dist/viewer.css';
// 从 vue 中导入 ref 和 onMounted
import { ref, onMounted } from 'vue';
// 引入 v-viewer 组件
import Viewer from 'v-viewer';
// 引入 baguetteBox 库
import baguetteBox from '../../static/js/baguetteBox.min.js';

// 使用 ref 创建响应式数据 images
const images = ref(' ');

// 定义 ready 方法，用于初始化 baguetteBox
const ready = () => {
  baguetteBox.run('.tz-gallery');
};

// 组件挂载后执行 ready 方法
onMounted(() => {
  ready();
});
</script>

<style scoped>
.gallery-container h1 {
  text-align: center;
  margin-top: 70px;
  font-family: 'Droid Sans', sans-serif;
  font-weight: bold;
  color: #58595a;
}

.gallery-container p.page-description {
  text-align: center;
  margin: 30px auto;
  font-size: 18px;
  color: #85878c;
}

.tz-gallery {
  padding: 40px;
}

.tz-gallery .thumbnail {
  padding: 0;
  margin-bottom: 30px;
  border-radius: 4px;
  border: none;
  transition: 0.15s ease-in-out;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.06);
}

.tz-gallery .thumbnail:hover {
  transform: translateY(-10px) scale(1.02);
}

.tz-gallery .lightbox img {
  border-radius: 4px 4px 0 0;
}

.tz-gallery .caption {
  padding: 26px 30px;
  text-align: center;
}

.tz-gallery .caption h3 {
  font-size: 14px;
  font-weight: bold;
  margin-top: 0;
}

.tz-gallery .caption p {
  font-size: 12px;
  color: #7b7d7d;
  margin: 0;
}

.baguetteBox-button {
  background-color: transparent !important;
}

.thumbnail img {
  width: 224px;
  height: 300px;
}

@media (min-width: 768px) {
  .thumbnail img {
    width: 120px;
    height: 240px;
  }

  @media (min-width: 1360px) {
    .thumbnail img {
      width: 220px;
      height: 280px;
    }
  }
}
</style>